import { Injectable } from '@angular/core';

import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class LogoutTimerService {
    private _counter = 0;
    private _stopTimer = false;
    private _timerReset$: Subject<void> = new Subject<void>();

    timerReset$ = this._timerReset$.asObservable();
    displayTime: string;
    timeout: NodeJS.Timeout;
    logoutCount = TimerValues.TWENTYFIVEMINUTES;
    warningMessageCount = TimerValues.FIVEMINUTES;

    constructor() { }

    stopTimer(): void {
        clearInterval(this.timeout);
        this._counter = this.logoutCount;
        this._stopTimer = true;
    }

    resetTimer(): void {
        sessionStorage.timeExpired = false;
        this._counter = this.logoutCount;
        this._stopTimer = false;
        this._timerReset$.next();
    }

}

enum TimerValues {
    FIVEMINUTES = 5 * 60,
    TWENTYFIVEMINUTES = 25 * 60
}
